<template>
	<div class="content" >
		<div class="menu-warp">
			<div class="container">
				<Menubar></Menubar>
			</div>

		</div>
		<div class="submenu-warp" >

			<div class="container">
				<input type="checkbox" id="curriculumMenu" v-model="submenuCtrl"/>
				<label id="curriculumMenuTitle" for="curriculumMenu">
					<div>
						<span>{{subTitle}}</span>
					</div>
				</label>

				<ul  id="submenu">
					<li v-for="menu in menuList">
						<router-link  :to="menu.url" >{{menu.menuTitle}}</router-link>

						<ul v-if="menu.submenu">
							<li v-for="subMenu in menu.submenu">
								<router-link  :to="subMenu.url" ><span>{{subMenu.menuTitle}}</span></router-link>
								<!-- <a v-smooth-scroll :href="subMenu.url">{{subMenu.menuTitle}}</a> -->
							</li>


						</ul>
					</li>
				</ul>


			</div>

		</div>
		<div class="page">
			<div class="container ">
				<component :is="loadSubmenu"  :menuType="menuType"></component>
				<div v-if="submenuType" class="sub-component">
						<component :is="loadSubComponent" :menuType="menuType+'_'+submenuType"></component>
				</div>

			</div>
		</div>

		<Footer>

		</Footer>
	</div>

</template>
<script>
import Menubar from '../../components/menubar/MobileLayout.vue'
import Footer from '@/components/footer/FooterMobile.vue'
import MenuList from '../../text/curriculum/menu.js'

export default {
  name: 'CurriculumLaptopFrame',
	components:{ Menubar,Footer},
	props:['menuType','submenuType'],
  data () {

	  	let title=this.changeSubTitle();
		let menu = MenuList.menuList[this.$store.state.lang];
	    return {
			menuList:menu,
			subTitle:title,
			submenuCtrl:false
	    }
	},
	methods:{

		checkUrl(url){
			if(this.$route.path.indexOf(url) != -1){
				return "router-link-exact-active";
			}
			return "";
		},
		changeSubTitle(){
			let title = '';
			let menu = MenuList.menuList[this.$store.state.lang];
			for(var i in MenuList.menuList[this.$store.state.lang]){
				let menuUrl = menu[i].url;
				if(menu[i].submenu){
					for(var j in menu[i].submenu){
						menuUrl = menu[i].submenu[j].url;
						if(menuUrl == this.$route.path){
							title =menu[i].submenu[j].menuTitle;
						}
					}
				}else{
					if(menuUrl == this.$route.path){
						title =menu[i].menuTitle;
					}
				}
			}
			return title;
		}

	},
	computed:{
		loadSubmenu(){
			let componentType = MenuList.contentType[this.menuType]
                ? MenuList.contentType[this.menuType]
                : this.menuType;
            componentType = componentType.charAt(0).toUpperCase() + componentType.slice(1);
            return () => import("./" + componentType + "Mobile.vue");
		},
		loadSubComponent(){
			let componentType = MenuList.contentType[
                this.menuType + "_" + this.submenuType
            ]
                ? MenuList.contentType[this.menuType + "_" + this.submenuType]
                : this.submenuType;
            componentType = componentType.charAt(0).toUpperCase() + componentType.slice(1);
            return () => import("./" + componentType + "Mobile.vue");
		}


	},
	watch:{
		'$route'(to, from){
			if(to.fullPath != from.fullPath){
				this.submenuCtrl = false;

				this.subTitle=this.changeSubTitle();
			}

		}
	}

}
</script>

<style  scoped>
.content{
	width:100%;
	overflow: hidden;

	min-height: 100vh;
}

.container{
	margin: 0 auto;
	height: auto;
	min-height: 100px;
		width:720px;
		padding: 0 35px;
}
.page {
	padding-top:68px;
		background-color: #fffcf7;
		padding-bottom: 200px;
		min-height: 600px;
}
.menu-warp{
	height:100px;
	width: 100%;
	background-color: #42c0ff;
	z-index: 50;
	position: relative;
}
.submenu-warp{
	height:100px;
	width: 100%;
background-color: #fffcf7;
	border-bottom: solid 2px #e6e6e6;
}
.submenu-warp .cover{
	position: absolute;
	left: 0;
	top: 0;
	height:100%;
	width: 100%;
	background-color:#00000030;
	display: none;
	z-index: 5;
}
#curriculumMenu{
	display: none;
}
#curriculumMenuTitle{
	z-index: 10;
	width: 100%;
	height: 100%;

}
#curriculumMenuTitle>div{
	font-size: 28px;
	  font-weight: bold;
	  font-style: normal;
	  font-stretch: normal;
	  line-height: normal;
	  letter-spacing: -1px;
	  color: #41403e;
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	  height: 100px;
	  z-index: 10;
	  position: relative;
	  margin:0  -35px;
	  padding: 0 35px;
	  background-color: #fffcf7;
	  	border-bottom: solid 2px #e6e6e6;


}
#curriculumMenuTitle>div::after{
	content:url('../../assets/curriculum/icon-down-arrow-m.svg');
	top:8px;
	position: relative;
}
#curriculumMenu ~ ul{
	list-style-type: none;
	opacity: 0;
	/* transition: all 0.5s linear; */
	 transform: translateY(-100%);
 	z-index: 8;
	margin:0;
	padding:0;
	position: absolute;
	background-color: #fffcf7;
	width: 100%;
	left:0;
	padding: 60px 0;

	overflow-y: auto;
	font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.6px;
  color: #41403e;

}
#curriculumMenu ~ ul li{
	min-height: 70px;
	width: 100%;
}
#curriculumMenu ~ ul li a{
	width: 720px;
	padding:0 35px;
	margin: 0 auto;
	height: 70px;
	display: flex;
	align-items: center;

}
#curriculumMenu ~ ul li a span{
	display: flex;
	align-items: center;
	width:720px;
	margin: 0 auto;
	padding:0 35px;
}
#curriculumMenu ~ ul li ul{
	padding-left: 28px;
	list-style-type: none;
}
#curriculumMenu:checked ~ #curriculumMenuTitle>div::after{
	transform:rotate(180deg);
	top:3px;
}
#curriculumMenu:checked ~ .cover{
	display: block;
}
#curriculumMenu:checked ~ ul{
	transform: translateY(0px);
	opacity:1;
}

a.router-link-active{
	font-weight: bold;
	font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.6px;
  color: #42c0ff;

}
.sub-component {
	margin-top:60px;
	padding-top:60px;
	border-top:2px solid #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/pages/curriculum/CurriculumMobile.vue